import { Section } from "@/components/section";
import { cn } from "@/lib/utils";
import type { Filial } from "@/types/data";
import { MapPinnedIcon } from "lucide-react";
import { LocationCard } from "./location-card";

interface LocationsSectionProps {
	headquarters: Filial;
	branches?: Filial[];

	title?: string;
	description?: string;
}

export function LocationsSection({
	headquarters,
	branches = [],
	title = "Nossas Unidades",
	description = "Encontre a unidade mais próxima de você e venha nos visitar",
}: LocationsSectionProps) {
	const activeBranches = branches.filter((branch) => branch.endereco.ativo);
	const hasBranches = activeBranches.length > 0;

	return (
		<Section className="bg-white lg:py-24">
			<div className="mb-12 text-center md:mb-14">
				<div className="mb-4 flex justify-center">
					<div className="rounded-full border border-brand-100 bg-brand-50 p-3">
						<MapPinnedIcon className="h-10 w-10 text-brand-700 md:h-11 md:w-11" />
					</div>
				</div>
				<h2 className="text-balance text-3xl font-bold tracking-tight text-brand-500 md:text-4xl">
					{title}
				</h2>
				<p className="mx-auto mt-4 max-w-2xl text-pretty text-base text-zinc-600 md:text-lg">
					{description}
				</p>
			</div>

			<div className="grid auto-rows-fr grid-cols-1 gap-6 md:grid-cols-2 md:gap-8 xl:grid-cols-3">
				<div
					className={cn(
						"relative",
						headquarters && !hasBranches && "md:col-span-2 xl:col-span-3",
					)}
				>
					<LocationCard unidade={headquarters} isHeadquarters={true} />
				</div>
				{activeBranches.map((branch, index) => (
					<LocationCard key={index} unidade={branch} />
				))}
			</div>
		</Section>
	);
}
